import { useTranslation } from "react-i18next";
import { Box, Divider, Typography, CircularProgress, Button } from "@mui/material";
import { LoadingButton } from "@mui/lab";

import { Comment as CommentType } from "../../../types/comment.type";
import { useCommentListQuery } from "../../../api/queries/useCommentListQuery";

import Comment from "./Comment";
import MakeCommentField from "./MakeCommentField";

const PostComments = ({ postId }: { postId: number }) => {
  const { t } = useTranslation("feed", { keyPrefix: "comment" });

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading, isError } = useCommentListQuery({
    postId,
  });

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", p: 2 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (isError) {
    return (
      <Button
        onClick={() => {}}
        sx={{
          color: "var(--Red---100, #FF4D4E)",
          fontFamily: "Montserrat",
          fontSize: "14px",
          fontWeight: 600,
          lineHeight: "20px",
          padding: 0,
          minWidth: "unset",
          background: "transparent !important",
        }}
        disableRipple
      >
        {t("somethingWrongRetrieveComments")}
      </Button>
    );
  }

  const comments = data?.comments || [];
  const mentionedUsers = data?.mentionedUsers || [];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "16px",
        flexGrow: 1,
      }}
    >
      {comments.length > 0 &&
        comments.map((comment: CommentType) => (
          <Comment comment={comment} key={comment.id} mentionedUsers={mentionedUsers} postId={postId} />
        ))}

      {hasNextPage && (
        <LoadingButton
          onClick={() => !isFetchingNextPage && fetchNextPage()}
          sx={{
            color: "var(--Dark---1000, #111)",
            fontFamily: "Montserrat",
            fontSize: "14px",
            fontWeight: 600,
            lineHeight: "20px",
            padding: 0,
            minWidth: "unset",
            width: "fit-content",
            background: "transparent !important",
          }}
          loading={isFetchingNextPage}
          disableRipple
        >
          {t("loadComments")}
        </LoadingButton>
      )}

      {comments.length === 0 && <Typography sx={{ textAlign: "center" }}>{t("noCommentsYet")}</Typography>}

      <Box sx={{ flexGrow: 1 }} />

      <Divider sx={{ margin: "0 -16px 0" }} />
      <MakeCommentField postId={postId} />
    </Box>
  );
};

export default PostComments;
